import { render, staticRenderFns } from "./points.vue?vue&type=template&id=d232751c&scoped=true"
import script from "./points.vue?vue&type=script&lang=js"
export * from "./points.vue?vue&type=script&lang=js"
import style0 from "./points.vue?vue&type=style&index=0&id=d232751c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d232751c",
  null
  
)

export default component.exports